import React from 'react';
import { Form } from 'antd';
import ReadingInput from './ReadingInput';
import styles from '../RemoveTenantFromRoomModal.module.scss';

const MeterReadingFields = ({ meters, getFieldDecorator }) => {
  const checkReading = (val, callback, currentReading) => {
    const value = val.reading.replace(',', '.').trim();

    if (value === '') {
      return callback(`Введите показания`);
    } else if (isNaN(Number(value))) {
      return callback(`Значение должно быть числом`);
    } else if (Number(value) >= currentReading) {
      return callback();
    } else {
      return callback(
        `Показания не могут быть меньше текущих — ${currentReading}`
      );
    }
  };

  return (
    <ul className={styles.meterList}>
      {meters.map((meter) => (
        <li key={meter.id} className={styles.meterItem}>
          <p className={styles.meterTypeName}>{meter.type?.name || '-'}</p>
          <Form.Item
            label="Показания"
            className={styles.meterFieldWrapper}
            colon={false}
          >
            {getFieldDecorator(`reading-${meter.id}`, {
              initialValue: {
                reading: String(meter.currentReading),
                id: meter.id,
                tariffId: meter.type.id,
              },
              rules: [
                {
                  validator: (_rule, value, callback) =>
                    checkReading(value, callback, meter.currentReading),
                },
              ],
            })(<ReadingInput />)}
          </Form.Item>
        </li>
      ))}
    </ul>
  );
};

export default MeterReadingFields;
